import Mutations from '../../odata/mutations';

export default { ...new Mutations('productSpecSheetImage'), ...new Mutations('productSpecSheetImages') };
